<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  ipg:{
    required: true,
  }
})
const {t: $t} = useI18n()
const emit = defineEmits(['close']);
function close() {
  emit('close')
}

const requestParams = ref({
  title: null,
})
const slug = ref(null)
const data = null;
const date = "";
const isLoadingFlag = ref(false)

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

</script>

<template>
  <section>
    <BaseDialog
        :size="'lg'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="$t('title.ipg')"
        @close="close"
    >
      <div class="overflow-auto max-h-96 p-2 px-4 mb-2">
        <vue-json-pretty :data="ipg" dir="ltr"/>
      </div>
      <template v-slot:footer>
        <div class="flex col-md-12 items-end justify-end gap-2">
          <Button variant="outline-secondary" @click="close" size="sm" class=" shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
  </section>
</template>

<style scoped>

</style>